"use strict";

var solutionsSDK = require('@nackle/solutions-sdk');
var _require = require('../utils/endpoints'),
  solutionsUrl = _require.solutionsUrl;
var _require2 = require('../utils/error'),
  throwServiceError = _require2.throwServiceError;
var SERVICE_NAME = 'solutions';
module.exports = function (_ref) {
  var fetch = _ref.fetch;
  var sdk = new solutionsSDK(solutionsUrl, fetch);
  function getSolutions(personId) {
    return new Promise(function ($return, $error) {
      var _await$sdk$getSolutio, solutions;
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getSolutions');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(sdk.getSolution('/solutions')).then(function ($await_3) {
          try {
            _await$sdk$getSolutio = $await_3, solutions = _await$sdk$getSolutio.solutions;
            return $return(solutions);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  }
  var getSolution = function getSolution(solutionId) {
    return new Promise(function ($return, $error) {
      var _await$sdk$getSolutio2, solutions;
      var $Try_2_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_2_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getSolution');
          return $Try_2_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(sdk.getSolution('/solutions')).then(function ($await_4) {
          try {
            _await$sdk$getSolutio2 = $await_4, solutions = _await$sdk$getSolutio2.solutions;
            if (Array.isArray(solutions)) {
              if (solutionId) {
                return $return(solutions.find(function (s) {
                  return s.id === solutionId;
                }));
              }
              // if no solutionId was passed in, return the first solution
              return $return(solutions[0]);
            }
            return $Try_2_Post();
          } catch ($boundEx) {
            return $Try_2_Catch($boundEx);
          }
        }, $Try_2_Catch);
      } catch (error) {
        $Try_2_Catch(error)
      }
    });
  };
  return {
    getSolutions: getSolutions,
    getSolution: getSolution
  };
};
//# sourceMappingURL=solution.js.map